module.exports = __webpack_public_path__ + "static/img/product04-3.002b714d.png";